/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullInterventionDefinitionViewModel } from './FullInterventionDefinitionViewModel'; 

export function getFullInterventionDefinitionsOptions(interventions: string, onSuccess?: (result: FullInterventionDefinitionViewModel[]) => void) {
	return queryOptions({
		queryKey: ['full-intervention-definitions', interventions],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/getfullinterventiondefinitions/' + '?interventions=' + interventions;
			const resp = await axios.get<FullInterventionDefinitionViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(interventions)
	});
}